/**
 * Format an optional value for display in a table cell or label. Returns the
 * stringified value when present, otherwise the project-wide missing-value
 * indicator `--`.
 *
 * E.g:
 *  formatOptional('PELVIS') => 'PELVIS'
 *  formatOptional(123)      => '123'
 *  formatOptional(undefined) => '--'
 */
export function formatOptional(value: string | number | undefined | null): string {
    return value == null ? '--' : String(value);
}